<template>
  <div >

    <div class="d-flex flex-column justify-space-between align-center">
      <v-img aspect-ratio="1" width="100%" max-width="200px" contain src="@/assets/Hand.svg"></v-img>
      <h1 class="display-1 font-weight-bold ma-5 white--text">Choose wisely</h1>
    </div>

    <div class="d-flex flex-column justify-space-between align-center">
      <v-form
          ref="form"
          v-model="valid"
          lazy-validation
      >

        <v-radio-group
            v-model="question"
            column
            color="primary"
        >
          <v-radio
              color="primary"
              label="I'm sending greetings to the world from ..."
              value="I'm sending greetings to the world from..."
          ></v-radio>
          <v-radio
              color="primary"
              label="My religion means to me..."
              value="My religion means to me..."
          ></v-radio>
          <v-radio

              color="primary"
              label="Intergenerational Dialogue is important, because..."
              value="Intergenerational Dialogue is important, because..."
          ></v-radio>
          <v-radio
              color="primary"
              label="Faith and Diplomacy must work closely together, because..."
              value="Faith and Diplomacy must work closely together, because..."
          ></v-radio>
          <v-radio
              color="primary"
              label="Religions for Peace means to me..."
              value="Religions for Peace means to me..."
          ></v-radio>
        </v-radio-group>
      </v-form>
    </div>

    <stepper-footer @cancel="$emit('cancel')" @finished="validate"/>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import StepperFooter from "../components/StepperFooter";

export default {
  name: 'StepQuestion',
  components: {
    StepperFooter
  },
  data: () => ({
    question: null,
    valid: false,
  }),
  // ...
  computed: {
    ...mapState({
      form: state => state.form
    })
  },
  methods: {
    validate() {

      this.$store.commit('setQuestion', this.question);
      this.$emit('finished');
    }
  }
}
</script>

<style>


</style>
